import React, { Component, createRef, useState, useRef, useEffect } from "react";
import Axios from "axios";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import $ from "jquery";
import { Row, Col, Card, Button, Space, Typography, Table, Input, Modal, Checkbox, Dropdown, Tooltip, InputNumber, Empty, Tag, Popconfirm, Pagination } from "antd";
import _ from "lodash";
import { faEdit, faTrash } from "@fortawesome/free-solid-svg-icons";

function SecurityProfiles(props) {
  const [securityProfiles, setSecurityProfiles] = useState([]);
  const [webPages, setWebPages] = useState([]);
  const [selectedSecurityProfile, setSelectedSecurityProfile] = useState(null);

  const [modalWidth, setModalWidth] = useState(1600);
  const [modalOpen, setModalOpen] = useState(false);

  const [selectedRowKeys, setSelectedRowKeys] = useState([]);

  const GetSecurityProfiles = async () => {
    let response = await props.AxiosRequest("/api/security-profiles/get");
    setSecurityProfiles(response.data.security_profiles);
  };
  const GetWebPages = async () => {
    let response = await props.AxiosRequest("/api/web-pages/get");
    setWebPages(response.data.web_pages);
  };

  const AddSecurityProfile = async () => {
    if (!selectedSecurityProfile?.name) return props.MakeNotification("warning", "Please fill in all the required fields.");
    await props.AxiosRequest("/api/security-profiles/insert", { ...selectedSecurityProfile });
    GetSecurityProfiles();
    setModalOpen(false);
  };
  const UpdateSecurityProfile = async () => {
    if (!selectedSecurityProfile?.name) return props.MakeNotification("warning", "Please fill in all the required fields.");
    await props.AxiosRequest("/api/security-profiles/update", { ...selectedSecurityProfile });
    GetSecurityProfiles();
    setModalOpen(false);
  };

  const DeleteSecurityProfile = async (id) => {
    await props.AxiosRequest("/api/security-profiles/delete", { id });
    GetSecurityProfiles();
  };
  const OnSelectWebPageChange = async (newSelectedRowKeys) => {
    setSelectedSecurityProfile({
      ...selectedSecurityProfile,
      web_pages: selectedSecurityProfile.web_pages.map((m) => {
        if (newSelectedRowKeys.includes(m.id)) return { ...m, viewable: 1, editable: 1 };
        return { ...m, viewable: 0, editable: 0 };
      }),
    });
    setSelectedRowKeys(newSelectedRowKeys);
  };

  const rowSelection = {
    selectedRowKeys,
    onChange: OnSelectWebPageChange,
  };

  useEffect(() => {
    GetSecurityProfiles();
    GetWebPages();
  }, []);

  useEffect(() => {
    const resize = () => {
      const maxSize = Math.min(1600, window.innerWidth);
      setModalWidth(maxSize);
    };
    window.addEventListener("resize", resize);
  });

  const security_profiles_columns = [
    {
      title: "Name",
      dataIndex: "name",
      key: "name",
      sorter: (a, b) => (a.name > b.name ? 1 : -1),
      defaultSortOrder: "ascend",
    },
    {
      title: "Users In Group",
      dataIndex: "users_list",
      key: "users_list",
      render: (value, object) => <Tooltip title={value}>{_.truncate(value, { separator: ", ", length: 128 })}</Tooltip>,
    },
    {
      title: "Actions",
      align: "right",
      dataIndex: "id",
      key: "id",
      render: (value, object) => (
        <Space>
          <Button
            size="small"
            type="primary"
            onClick={() => {
              let found_security_profile = securityProfiles.find((f) => f.id === value);
              setSelectedRowKeys(found_security_profile.web_pages.filter((f) => f.viewable).map((m) => m.id));
              setSelectedSecurityProfile({
                ...found_security_profile,
                web_pages: found_security_profile.web_pages.map((wp) => {
                  return { ...wp, key: wp.id };
                }),
              });
              setModalOpen(true);
            }}
          >
            <FontAwesomeIcon icon={faEdit} className="mr-1" />
            Edit
          </Button>

          <Popconfirm
            title="Are you sure?"
            description={"Are you sure you want to delete " + object.name + "?"}
            onConfirm={() => {
              DeleteSecurityProfile(object.id);
            }}
          >
            <Button size="small" danger>
              <FontAwesomeIcon icon={faTrash} className="mr-1" />
              Delete
            </Button>
          </Popconfirm>
        </Space>
      ),
    },
  ];
  const web_pages_columns = [
    {
      title: "Name",
      dataIndex: "name",
      key: "name",
    },
    {
      title: "Description",
      dataIndex: "description",
      key: "description",
    },
  ];

  return (
    <main className="content">
      <div className="container-fluid">
        <div className="header">
          <h1 className="header-title">Security Profiles</h1>
        </div>
        <Row gutter={[16, 16]}>
          <Col span={24}>
            <Card
              title={<>Security Profiles</>}
              style={{
                width: "100%",
              }}
              extra={
                <Button
                  type="primary"
                  onClick={() => {
                    setSelectedSecurityProfile({
                      web_pages: webPages.map((wp) => {
                        return { ...wp, viewable: 0, editable: 0, key: wp.id };
                      }),
                    });
                    setModalOpen(true);
                  }}
                >
                  <FontAwesomeIcon icon="plus" className="me-2" /> Add A New Security Profile
                </Button>
              }
            >
              <Table columns={security_profiles_columns} dataSource={securityProfiles}></Table>
            </Card>
          </Col>
        </Row>
      </div>
      <Modal
        title={selectedSecurityProfile?.id ? "Edit Security Profile" : "Add New Security Profile"}
        centered
        width={modalWidth}
        open={modalOpen}
        onCancel={() => {
          setModalOpen(false);
          setSelectedSecurityProfile({
            web_pages: webPages.map((wp) => {
              return { ...wp, viewable: 0, editable: 0, key: wp.id };
            }),
          });
        }}
        footer={
          <>
            <Button
              onClick={() => {
                setModalOpen(false);
                setSelectedSecurityProfile({
                  web_pages: webPages.map((wp) => {
                    return { ...wp, viewable: 0, editable: 0, key: wp.id };
                  }),
                });
              }}
            >
              Cancel
            </Button>
            <Button
              type="primary"
              onClick={
                selectedSecurityProfile?.id
                  ? () => {
                      UpdateSecurityProfile();
                    }
                  : () => {
                      AddSecurityProfile();
                    }
              }
            >
              {selectedSecurityProfile?.id ? "Save Changes" : "Add Security Profile"}
            </Button>
          </>
        }
      >
        <Row gutter={[16, 16]}>
          <Col span={24}>
            <label className="col-form-label-sm">Security Profile Name *</label>
            <Input
              value={selectedSecurityProfile?.name}
              onChange={(e) => {
                setSelectedSecurityProfile({ ...selectedSecurityProfile, name: e.target.value });
              }}
            />
          </Col>
          <Col span={24}>
            <hr />
          </Col>
          <Col span={24} style={{ maxHeight: "55vh", overflow: "scroll", overflowY: "scroll" }}>
            <Table columns={web_pages_columns} dataSource={selectedSecurityProfile?.web_pages} rowSelection={rowSelection} pagination={{ pageSize: 200 }} />
          </Col>
        </Row>
      </Modal>
    </main>
  );
}

export class SecurityProfilesOld extends Component {
  constructor(props) {
    super(props);
    this.DeleteModalCloseButton = createRef();
    this.state = {
      security_profiles: [],
      selected_profile: { id: -1, name: "", details: [] },
      security_profile_to_add: "",
    };
  }
  componentDidMount() {
    this.GetSecurityProfiles();
  }
  GetSecurityProfiles = () => {
    Axios.post(window.location.protocol + "//" + window.location.hostname + (window.location.port === "3000" ? ":3001" : "") + "/api/security-profile/get/all", {
      "x-access-token": this.props.authToken,
    })
      .then((response) => {
        if (response["data"]["status"] === "Error") {
          this.props.MakeNotification("error", response["data"]["message"] || "There was a backend error. Please try again.");
        }
        if (response["data"]["status"] === "success") {
          let d = response.data.security_profiles;
          d = d.map((e) => {
            return {
              ...e,
              details: response.data.security_profile_details.filter((f) => {
                return f.id === e.id;
              }),
            };
          });
          if ($.fn.DataTable.isDataTable("#datatables-security-profiles")) $("#datatables-security-profiles").DataTable().destroy();
          this.setState({ security_profiles: [...d] }, (e) => {
            if (this.state.selected_profile.id === -1) {
              this.setState({ selected_profile: this.state.security_profiles[0] });
            }

            $("#datatables-security-profiles").DataTable({
              language: {
                lengthMenu: "Show _MENU_ entries &nbsp;&nbsp;&nbsp;",
              },
              pageLength: 10,
              pagingType: "simple",
              lengthMenu: [
                [3, 5, 10, -1],
                [3, 5, 10, "All"],
              ],
              order: [[0, "asc"]],
              dom: "lBfrtip",
              columnDefs: [
                {
                  targets: 0, //This prevents the ID column from showing.
                  className: "noVis",
                },
              ],
              buttons: {
                buttons: [
                  {
                    extend: "colvis",
                    columns: ":not(.noVis)",
                    collectionLayout: "fixed two-column",
                  },
                ],
                dom: {
                  button: {
                    className: "btn btn-info d-block mb-2",
                  },
                },
              },
            });
          });
        }
      })
      .catch((error) => {
        //handle errors
        console.log(error);
        this.props.MakeNotification("error", "There was an error. Please try again.");
      })
      .then(() => {});
  };
  SelectSecurityProfile = (e) => {
    $(".selected").removeClass("selected");
    $(e.target).closest("tr").addClass("selected");
    $("#user-add-card").fadeOut(500, () => {
      $("#user-detail-card").fadeOut(500, () => {
        $("#user-edit-card").fadeOut(500, () => {
          let id_clicked = Number($(e.target).closest("tr").attr("uid"));
          this.setState(
            {
              selected_profile: this.state.security_profiles.find((f) => {
                return f.id === id_clicked;
              }),
            },
            () => {
              $("#user-detail-card").fadeIn(500);
            },
          );
        });
      });
    });
  };
  PrepEditUser = (event) => {
    //prepare sidebar with info on adding user.
    $("#user-add-card").fadeOut(500, function () {
      $("#user-detail-card").fadeOut(500, function () {
        $("#user-edit-card").fadeOut(500, function () {
          $("#user-edit-card").fadeIn(500);
        });
      });
    });
  };
  PrepAddSecurityProfile = (event) => {
    //prepare sidebar with info on adding user.
    $("#user-add-card").fadeOut(500, function () {
      $("#user-detail-card").fadeOut(500, function () {
        $("#user-edit-card").fadeOut(500, function () {
          $("#user-add-card").fadeIn(500, () => {
            window.$("#user-add-name").focus();
          });
        });
      });
    });
  };
  RemovePrep = (event) => {
    //prepare sidebar with info on adding user.
    $("#user-add-card").fadeOut(500, function () {
      $("#user-detail-card").fadeOut(500, function () {
        $("#user-edit-card").fadeOut(500, function () {
          $("#user-detail-card").fadeIn(500);
        });
      });
    });
  };
  UpdateSecurityProfile = () => {
    Axios.post(window.location.protocol + "//" + window.location.hostname + (window.location.port === "3000" ? ":3001" : "") + "/api/security-profile/update", {
      "x-access-token": this.props.authToken,
      profile: this.state.selected_profile,
    })
      .then((response) => {
        if (response["data"]["status"] === "Error") {
          this.props.MakeNotification("error", response["data"]["message"] || "There was a backend error. Please try again.");
        }
        if (response["data"]["status"] === "success") {
          this.RemovePrep();
          this.GetSecurityProfiles();
        }
      })
      .catch((error) => {
        console.log(error);
        if (error.response && error.response.status === 401) {
          this.props.setRelogRequired(true);
        }
        this.props.MakeNotification("error", "There was an error. Please try again.");
      })
      .then(() => {
        // always executed
      });
  };
  AddSecurityProfile = () => {
    Axios.post(window.location.protocol + "//" + window.location.hostname + (window.location.port === "3000" ? ":3001" : "") + "/api/security-profile/insert", {
      "x-access-token": this.props.authToken,
      name: this.state.security_profile_to_add,
    })
      .then((response) => {
        if (response["data"]["status"] === "Error") {
          this.props.MakeNotification("error", response["data"]["message"] || "There was a backend error. Please try again.");
        }
        if (response["data"]["status"] === "success") {
          this.props.MakeNotification("success", response.data.message || "Successfully added new security profile.");
          this.RemovePrep();
          this.GetSecurityProfiles();
        }
      })
      .catch((error) => {
        //handle errors
        console.log(error);
        this.props.MakeNotification("error", "There was an error. Please try again.");
      })
      .then(() => {});
  };
  DeleteSecurityProfile = () => {
    Axios.post(window.location.protocol + "//" + window.location.hostname + (window.location.port === "3000" ? ":3001" : "") + "/api/security-profile/delete", {
      "x-access-token": this.props.authToken,
      security_profiles_id: this.state.selected_profile.id,
    })
      .then((response) => {
        if (response["data"]["status"] === "Error") {
          this.props.MakeNotification("error", response["data"]["message"] || "There was a backend error. Please try again.");
        }
        if (response["data"]["status"] === "success") {
          this.props.MakeNotification("success", response.data.message || "Successfully removed new security profile.");
          this.RemovePrep();
          this.GetSecurityProfiles();
          window.$("#defaultModalDanger").modal("hide");
        }
      })
      .catch((error) => {
        //handle errors
        console.log(error);
        this.props.MakeNotification("error", "There was an error. Please try again.");
      })
      .then(() => {});
  };
  render() {
    return (
      <main className="content">
        <div className="container-fluid">
          <div className="header">
            <h1 className="header-title">Security Profiles</h1>
          </div>
          <div className="row">
            <div className="col-md-7">
              <div className="card">
                <div className="card-header">
                  <div className="card-actions float-end">
                    <span id="refresh" className="clickable me-1" onClick={this.GetSecurityProfiles}>
                      <FontAwesomeIcon icon="sync" />
                    </span>
                    <span id="plus" className="clickable me-1" onClick={this.PrepAddSecurityProfile}>
                      <FontAwesomeIcon icon="plus" />
                    </span>
                  </div>
                  <h5 className="card-title mb-0">Security Profiles</h5>
                </div>
                <div className="card-body">
                  <table id="datatables-security-profiles" className="table table-striped hover" style={{ width: "100%" }}>
                    <thead>
                      <tr>
                        <th className="d-none"># </th>
                        <th>Name</th>
                        <th>Number of Users</th>
                      </tr>
                    </thead>
                    <tbody id="users-table-body">
                      {this.state.security_profiles.map((i) => (
                        <tr key={i.id} onClick={this.SelectSecurityProfile} uid={i.id}>
                          <td className="d-none">{i.id}</td>
                          <td>
                            <b>{i.name}</b>
                          </td>
                          <td>{i.num_users}</td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
            {/* //----------------------------|User Detail Card|----------------------------\\ */}
            <div className="col-md-5 sidebar-card" id="user-detail-card">
              <div className="card">
                <div className="card-header">
                  <div className="card-actions float-end">
                    <span id="edit" className="clickable me-1" onClick={this.PrepEditUser}>
                      <FontAwesomeIcon icon="edit" />
                    </span>
                    <span id="edit-confirm-button" className="clickable me-1" onClick={this.asdf} style={{ display: "none" }}>
                      <FontAwesomeIcon icon="check" style={{ color: "green" }} />
                    </span>
                  </div>
                  <h5 className="card-title mb-0 action-title">Security Profile Details</h5>
                </div>
                <div className="card-body">
                  <table className="table table-sm my-2">
                    <tbody id="action-header">
                      <tr>
                        <th>Name</th>
                        <td>{this.state.selected_profile.name}</td>
                        <td></td>
                        <td></td>
                      </tr>
                    </tbody>
                    <tbody id="action-body">
                      <tr>
                        <th>Page Name</th>
                        <th>Visible</th>
                        {/* <th>Editable</th> */}
                      </tr>
                      {this.state.selected_profile.details.map((i) => {
                        return (
                          <tr key={i.spwpx_id}>
                            <td>{i.name}</td>
                            <td>
                              <input className="form-check-input viewable" type="checkbox" id={i["spwpx_id"]} disabled={true} checked={i["viewable"] === 1 ? true : false} />
                            </td>
                            {/* <td>
                              <input className="form-check-input viewable" type="checkbox" id={i["spwpx_id"]} disabled={true} checked={i["editable"] == 1 ? true : false} />
                            </td> */}
                          </tr>
                        );
                      })}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
            {/* //----------------------------|End Detail Card|----------------------------\\ */}
            {/* //----------------------------|Edit Card|----------------------------\\ */}
            <div className="col-md-5 sidebar-card" id="user-edit-card" style={{ display: "none" }}>
              <div className="card">
                <div className="card-header">
                  <div className="card-actions float-end">
                    <span className="clickable me-1" onClick={this.UpdateSecurityProfile}>
                      <FontAwesomeIcon icon="check" className="pe-none clickable" style={{ color: "green" }} />
                    </span>
                    <span className="clickable me-1" onClick={this.RemovePrep}>
                      <FontAwesomeIcon icon="times" className="pe-none clickable" style={{ color: "red" }} />
                    </span>
                  </div>
                  <h5 className="card-title mb-0 action-title">Edit Security Profile</h5>
                </div>
                <div className="card-body">
                  <table className="table table-sm my-2">
                    <tbody id="action-header">
                      <tr>
                        <th>Name</th>
                        <td>
                          <input
                            type="text"
                            className="form-control"
                            value={this.state.selected_profile.name}
                            onChange={(e) => {
                              this.setState((prevState) => {
                                return { ...prevState, selected_profile: { ...prevState.selected_profile, name: e.target.value } };
                              });
                            }}
                          />
                        </td>
                        <td></td>
                        <td></td>
                      </tr>
                    </tbody>
                    <tbody id="action-body">
                      <tr>
                        <th>Page Name</th>
                        <th>Visible</th>
                        {/* <th>Editable</th> */}
                      </tr>
                      {this.state.selected_profile.details.map((i) => {
                        return (
                          <tr key={i.spwpx_id}>
                            <td>{i.name}</td>
                            <td>
                              <input
                                className="form-check-input viewable"
                                type="checkbox"
                                id={i["spwpx_id"]}
                                onChange={(e) => {
                                  this.setState((prevState) => {
                                    return {
                                      ...prevState,
                                      selected_profile: {
                                        ...prevState.selected_profile,
                                        details: [
                                          ...prevState.selected_profile.details.map((f) => {
                                            if (f.spwpx_id === Number(e.target.id)) return { ...f, viewable: e.target.checked ? 1 : 0 };
                                            return { ...f };
                                          }),
                                        ],
                                      },
                                    };
                                  });
                                }}
                                checked={i["viewable"] === 1 ? true : false}
                              />
                            </td>
                          </tr>
                        );
                      })}
                    </tbody>
                  </table>
                  <h4 style={{ textAlignLast: "center", paddingTop: "6px" }}>More Options </h4>
                  <hr></hr>
                  <button type="button" className="btn btn-outline-danger float-right" data-bs-toggle="modal" data-bs-target="#defaultModalDanger" style={{ float: "right" }}>
                    Delete Profile
                  </button>
                </div>
              </div>
            </div>
            {/* //----------------------------|User Add Card|----------------------------\\ */}
            <div className="col-md-5 sidebar-card" id="user-add-card" style={{ display: "none" }}>
              <div className="card">
                <div className="card-header">
                  <div className="card-actions float-end">
                    <span href="#" className="me-1 clickable" onClick={this.AddSecurityProfile}>
                      <FontAwesomeIcon icon="check" style={{ color: "green" }} />
                    </span>
                    <span href="#" className="me-1 clickable" onClick={this.RemovePrep}>
                      <FontAwesomeIcon icon="times" style={{ color: "red" }} />
                    </span>
                  </div>
                  <h5 className="card-title mb-0 action-title">Add a New Security Profile</h5>
                </div>
                <div className="card-body">
                  <table className="table table-sm my-2">
                    <tbody id="action-body">
                      <tr>
                        <th>Security Profile Name</th>
                        <td>
                          <input
                            id="user-add-name"
                            type="text"
                            name="first_name"
                            className="form-control"
                            value={this.state.security_profile_to_add}
                            onChange={(e) => {
                              this.setState({ security_profile_to_add: e.target.value });
                            }}
                          />
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
            {/* //----------------------------|End User Add Card|----------------------------\\ */}
          </div>
        </div>
        {/* //----------------------------|Confirm Delete Modal|----------------------------\\ */}
        <div className="modal fade" id="defaultModalDanger" tabIndex={-1} role="dialog" aria-hidden="true">
          <div className="modal-dialog" role="document">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Confirm Profile Delete</h5>
                <button type="button" id="user-delete-modal-close" className="btn-close" data-bs-dismiss="modal" aria-label="Close" ref={this.DeleteModalCloseButton} />
              </div>
              <div className="modal-body m-3">
                <p className="mb-0">Deleting a profile is a permanent operation. Please be confirm that you wish to delete the profile.</p>
              </div>
              <div className="modal-footer">
                <button type="button" className="btn btn-info" data-bs-dismiss="modal">
                  Close
                </button>
                <button type="button" className="btn btn-danger" onClick={this.DeleteSecurityProfile}>
                  Delete Profile
                </button>
              </div>
            </div>
          </div>
        </div>
        {/* //----------------------------|End Delete Modal|----------------------------\\ */}
      </main>
    );
  }
}

export default SecurityProfiles;
